// jsBridgeInterface.js
/* eslint-disable no-console */
'use client';
'use strict';

import { getIsOnWebviewApp } from '../resource/getUserAgent.js';

const isOnWebviewApp = getIsOnWebviewApp();

export const hasWebviewCallHandler = () => {
  return isOnWebviewApp && window.WebApp?.callHandler;
};

export const callWebviewHandler = (name, ...args) => {
  if (hasWebviewCallHandler()) {
    window.WebApp.callHandler(name, ...args);
  }
};
